import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { all_routes } from "../../../router/all_routes";
import TaxPage from "./TaxPage";
import { downloadBase64Pdf, fetchTaxSimplifierPdf, getLoggedInEmpId } from "./taxSimplifier.service";

const POINTS = [
  {
    icon: "ti-download",
    bg: "#fee2e2",
    fg: "#c0282c",
    title: "Point 1",
    description:
      "You can download the complete details of tax deduction and calculation with actual declarations by using the 'Download PDF' option. This provides you a detailed breakup of the last pay slip.",
  },
  {
    icon: "ti-chart-bar",
    bg: "#dbeafe",
    fg: "#1d4ed8",
    title: "Point 2",
    description:
      "You can compare/simulate the tax deduction and calculation of Old Tax Regime and New Tax Regime side by side by using the 'Simulate & Compare Tax Details' option.",
  },
  {
    icon: "ti-mail",
    bg: "#dcfce7",
    fg: "#15803d",
    title: "Point 3",
    description:
      "You can get the details of tax deduction and calculation with actual declarations through E-mail, by using the 'Send e-mail' option.",
  },
];

const TaxSimplifier: React.FC = () => {
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);

  const handleDownload = async () => {
    const empId = getLoggedInEmpId();
    if (!empId) {
      toast.error("Employee ID not found");
      return;
    }
    setDownloading(true);
    try {
      const content = await fetchTaxSimplifierPdf(empId);
      downloadBase64Pdf(content, "TaxSimplifierStatement.pdf");
      toast.success("Downloaded successfully");
    } catch (err: any) {
      toast.error(err?.message || "Something went wrong");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <TaxPage>
      <h4 className="tss-heading">What can you do?</h4>
      <p className="tss-subtitle">Everything you need to review and manage your tax statement.</p>

      {POINTS.map((point) => (
        <div className="tss-point" key={point.title}>
          <div className="tss-point-icon" style={{ background: point.bg, color: point.fg }}>
            <i className={`ti ${point.icon}`} />
          </div>
          <div>
            <h6>{point.title}</h6>
            <p>{point.description}</p>
          </div>
        </div>
      ))}

      <div className="tss-actions">
        <button type="button" className="tss-action tss-action-download" onClick={handleDownload} disabled={downloading}>
          <i className="ti ti-download" />
          {downloading ? "Downloading..." : "Download PDF"}
        </button>
        <button
          type="button"
          className="tss-action tss-action-compare"
          onClick={() => navigate(all_routes.taxSimplifierDetails)}
        >
          <i className="ti ti-chart-bar" />
          Simulate & Compare
        </button>
        <button type="button" className="tss-action tss-action-email" onClick={() => setEmailOpen(true)}>
          <i className="ti ti-mail" />
          Send e-mail
        </button>
      </div>

      {emailOpen && (
        <div className="tss-modal-backdrop" onClick={() => setEmailOpen(false)}>
          <div className="tss-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
            <i className="ti ti-circle-check text-success" style={{ fontSize: 48 }} />
            <p className="mt-3 mb-3">
              Tax Simplifier Statement successfully sent as an e-mail attachment.
            </p>
            <button type="button" className="btn btn-primary w-100" onClick={() => setEmailOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </TaxPage>
  );
};

export default TaxSimplifier;
